<template>
  <v-card>
    <div class="d-flex align-center justify-space-between">
      <div>
        <v-card-title class="text-no-wrap">
          Statut du retrait
        </v-card-title>
        <v-card-subtitle>Historique du statut</v-card-subtitle>
      </div>

      <v-avatar
        color="primary"
        size="48"
        class="v-avatar-light-bg primary--text me-5"
      >
        <v-icon
          size="30"
          color="primary"
        >
          {{ icons.mdiClockStart }}
        </v-icon>
      </v-avatar>
    </div>

    <v-card-text>
      <v-timeline
        dense
        class="timeline-custom-dense timeline-custom-dots"
      >
        <v-timeline-item
          v-for="status in statuses"
          :key="status.id"
          small
          color="transparent"
        >
          <template #icon>
            <v-avatar
              :color="status.color"
              class="v-avatar-light-bg primary--text"
              size="40"
            >
              <v-icon
                size="24"
                :color="status.color"
              >
                {{ status.pivot.is_active ? icons.mdiCheck : icons.mdiMinusCircleOutline }}
              </v-icon>
            </v-avatar>
          </template>
          <!-- Header -->
          <div class="d-flex justify-space-between">
            <p class="mb-1 text--primary font-weight-semibold">
              <v-chip
                small
                label
                :color="status.color"
              >
                {{ status.label }}
              </v-chip>
            </p>
          </div>

          <!-- Content -->
          <p>{{ formattingDate(status.pivot.created_at) }}</p>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiClockStart,
  mdiCheck,
  mdiMinusCircleOutline,
} from '@mdi/js'
import { formatDate } from '@core/date/dateFunctions'

export default {
  name: 'WithdrawalStatusList',
  props: {
    statuses: {
        type: Array,
        default: () => []
    }
  },
  setup() {
    const formattingDate = date => formatDate(date)

    return {
      formattingDate,
      icons: {
        mdiClockStart,
        mdiCheck,
        mdiMinusCircleOutline,
      },
    }
  },
}
</script>
